import { Injectable } from '@angular/core';
import { AuthService } from './auth.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AppInitService {
  constructor(private authService: AuthService) {}

  init(): Observable<boolean> {
    // Inicializar la autenticación verificando con el servidor si es necesario
    return this.authService.initializeAuth();
  }
}